const init = () => {
    $('a.share').shares();
}

export default {
    init
}